import { render, staticRenderFns } from "./InstallationAndDeliveryForm.vue?vue&type=template&id=54d838c6&scoped=true"
import script from "./InstallationAndDeliveryForm.vue?vue&type=script&lang=ts"
export * from "./InstallationAndDeliveryForm.vue?vue&type=script&lang=ts"
import style0 from "./InstallationAndDeliveryForm.vue?vue&type=style&index=0&id=54d838c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d838c6",
  null
  
)

export default component.exports